<template>
  <!-- Ticket -->
  <div class="participation-term-cemar" v-if="!loading" style="margin: 0.5cm;">
    <p>{{ ticket.event.city }}, {{ new Date() | moment('LL') }}</p>

    <p>
      É com grande satisfação que comunicamos que o Sr(a) {{ ticket.customer.holder }}, C/C {{ ticket.customer.uc }},
      CPF {{ ticket.customer.cpf }}, foi contemplado no {{ projectName }}, que prevê a substituição da sua geladeira
      antiga, com maior consumo de energia, por uma geladeira nova, mais eficiente e com selo Procel classe A em
      economia de energia. Assim como você, entre agosto/2018 e agosto/2019 também serão beneficiadas mais de 8.000
      famílias de comunidades baixa em municípios Maranhenses e bairros da grande São Luís.
    </p>
    <p>
      Essas ações confirmam, mais uma vez, o compromisso da {{ shortName }} em entender as necessidades dos seus clientes, através
      de campanhas de eficientização energética. O {{ projectName }}, regulamentado pela Agência Nacional de Energia
      Elétrica ANEEL, tem como objetivo reduzir o consumo, disseminar a cultura do uso racional da
      energia elétrica, além de proteger o meio ambiente, descartando as geladeiras antigas de forma ecologicamente
      correta. Tudo de acordo com a legislação do Conselho Nacional de Meio Ambiente (CONAMA)  proporcionando qualidade
      na distribuição de energia elétrica que é essencial para o conforto dos maranhenses e para o desenvolvimento do
      nosso Estado.
    </p>
    <p>
      Traga sua geladeira do dia {{ dateTimeDelivery }}, juntamente com a última conta de energia, documento de
      identidade e CPF. A {{ shortName }} conta com sua presença.
    </p>
    <p> <strong>PONTOS IMPORTANTES:</strong></p>
    <ol>
      <li>
        O benefício da geladeira está condicionada a autorização do titular da conta para realização de medições nas
        geladeiras após a troca, com o objetivo de determinar o percentual de economia.
      </li>
      <ul>
        <li>
          Caso você não compareça no dia e hora marcados ({{ dateTimeDelivery }}) perderá o benefício.
        </li>
        <li>
          Não é possível retirar a geladeira nova em outro dia ou horário diferente do estabelecido ({{ dateTimeDelivery }}).
        </li>
      </ul>
    </ol>

    <p style="text-align: center;">
      <signature-customer-ticket :customer="ticket.customer" />
    </p>

    <table>
      <thead>
        <th>CONF</th> <th>EGV</th> <th>DOC</th> <th>EGN</th>
      </thead>
      <tbody>
        <tr>
          <td></td>   <td></td>    <td></td>    <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import SignatureCustomerTicket from 'src/pages/Documents/SignatureCustomerTicket'
export default {
  name: 'participation-term-cemar',

  components: { SignatureCustomerTicket },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },

  data () {
    return {
      projectName: 'Programa de Eficiência Energética da CEMAR',
      shortName: 'CEMAR',
      numCities: 4,
      numFamilies: '600 mil',
      finance: '7 milhões',
      birthplace: 'maranhense',
      deliverDate: 'Amanhã é o grande dia'
    }
  },

  computed: {
    dateTimeDelivery () {
      return this.ticket.event.dateTimeDelivery && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(new Date(this.ticket.event.dateTimeDelivery)).format('LLL') : 'definido pelos membros da equipe'
    }
  },

  filters: {
    uppercase: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    }
  }
}
</script>
<style scoped>
  p, li {
    font-size: 10pt;
    text-align: justify;
  }

  table {
    border-spacing: 0.5rem;
    width: 100%;
  }

  td, th {
    text-align: center;
    border: 1px solid #999;
    padding: 0.5rem;
  }

  th {
    background-color: #ddd;
  }

  td {
    padding-bottom: 2cm;
    width: 25%;
  }
  @page
  {
      size: auto;   /* auto is the current printer page size */
      margin: 1cm;  /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/Cemar/ParticipationTermCemar.vue